// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const contentApi = baseApi.injectEndpoints({
  reducerPath: "contentApi",
  endpoints: (builder) => ({
    getAllContent: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `contents?${queryParams}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["User"],
    }),
    blockUnblockContent: builder.mutation({
      query: (id) => {
        return {
          url: `contents/block/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    changeUserContent: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `contents/${id}`,
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["User"],
    }),
    deleteContent: builder.mutation({
      query: (id) => {
        return {
          url: `contents/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const {
  useDeleteContentMutation,
  useGetAllContentQuery,
  useChangeContentPassMutation,
  useBlockUnblockContentMutation,
} = contentApi;
